export const globalOverlayContainer = document.createElement('div')

const appScopeSelector = (import.meta.env.VITE_APP_SCOPE_SELECTOR as string | undefined) || '.sbb-chat'

if (appScopeSelector.startsWith('.')) {
  globalOverlayContainer.classList.add(appScopeSelector.substring(1))
}

document.body.appendChild(globalOverlayContainer)
